import { Component, OnInit, Input } from '@angular/core';
import PaginatedList from 'models/paginated-list/paginated-list.model';
import Ticket from 'models/ticket/ticket.model';
import Project from 'models/project/project.model';
import { Router, ActivatedRoute } from '@angular/router';
import { TicketService } from 'services/ticket/ticket.service';
import { ArcgisMapService } from 'services/arcgis-map/arcgis-map.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProjectService } from 'services/project/project.service';
import { BehaviorSubject, Subscription, Subject } from 'rxjs';
import ExternalLayer from 'models/external-layer/external-layer.model';
import ExternalFeature from 'models/external-feature/external-feature.model';
import { TicketAttributeService } from 'services/ticket-attribute/ticket-attribute.service';
import TicketAttribute from 'models/ticket-attribute/ticket-attribute.model';
import TicketAttributeValue from 'models/ticket-attribute-value/ticket-attribute-value.model';

@Component({
  selector: 'app-list-hybrid-tickets',
  templateUrl: './list-hybrid-tickets.component.html',
  styleUrls: ['./list-hybrid-tickets.component.scss']
})
export class ListHybridTicketsComponent implements OnInit {

  public page: PaginatedList<Ticket> = new PaginatedList();
  public ticket: Ticket = new Ticket();
  public project: Project = new Project();
  public ticketAttributes: TicketAttribute[] = [];
  public ticketAttributeSubscription: Subscription;
  public layerListSubject: BehaviorSubject<ExternalLayer[]> = new BehaviorSubject([]);
  public currentIndex = 0;
  @Input() clickedFeature: BehaviorSubject<ExternalFeature> = new BehaviorSubject(new ExternalFeature());
  public attributeFilledSubject: Subject<TicketAttributeValue> = new Subject();

  constructor(public router: Router,
              private route: ActivatedRoute,
              public ticketService: TicketService,
              public ticketAttributeService: TicketAttributeService,
              public arcgisMapService: ArcgisMapService,
              public snackBar: MatSnackBar,
              public projectService: ProjectService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      if (params.project && params.page && params.limit) {
        await this.projectService.select(params.project);
      }
    });
    this.arcgisMapService.disableSelection();
    this.projectService.getSelectedInstance().subscribe(async p => {
      this.project = p;
      this.layerListSubject.next(this.project.externalLayers);
      if (this.project.id.length > 0) {
        await this.ticketAttributeService.selectList(this.project);
        this.ticket.project = this.project;
      }
    });

    this.ticketAttributeSubscription = this.ticketAttributeService.getSelectedList()
    .subscribe(r => this.ticketAttributes = r);

    this.clickedFeature.subscribe(f => {
      if (f.objectId.length > 0) {
        this.ticket.externalFeatures = [f];
        this.ticket.position = f.position;
      }
    });

    this.attributeFilledSubject.subscribe(v => {
      this.ticket.ticketAttributeValues = this.ticket.ticketAttributeValues.filter(attr => attr.ticketAttribute.id !== v.ticketAttribute.id);
      this.ticket.ticketAttributeValues.push(v);
      this.currentIndex++;

      if (this.currentIndex >= this.ticketAttributes.length) {
        this.save();
      }
    });
  }

  async save() {
    let txt = 'Létrehozás sikeres';
    try {
      await this.ticketService.create(this.ticket);
    } catch (ex) {
      console.error(ex);
      txt = 'Létrehozás sikertelen.';
    } finally {
      this.snackBar.open(txt, '', {
        duration: 2000
      });
    }
  }
}
